// Platform detection utilities for adaptive video call behavior

export const isMobileDevice = (): boolean => {
  return /iPhone|iPad|iPod|Android|webOS|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
}

export const isTablet = (): boolean => {
  return /iPad|Android(?=.*\bMobile\b)/i.test(navigator.userAgent) && window.innerWidth >= 768
}

export const isCapacitorApp = (): boolean => {
  // Check if running in Capacitor (native app environment)
  return typeof window !== 'undefined' && window.Capacitor !== undefined
}

export const isTouchDevice = (): boolean => {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0
}

export const getScreenSize = (): 'small' | 'medium' | 'large' => {
  const width = window.innerWidth
  if (width < 768) return 'small'
  if (width < 1024) return 'medium'
  return 'large'
}

export const shouldUsePopupWindow = (): boolean => {
  // Use popup windows only on desktop with large screens
  const isDesktop = !isMobileDevice() && !isCapacitorApp() && !isTouchDevice()
  const hasLargeScreen = getScreenSize() === 'large'

  return isDesktop && hasLargeScreen
}

export const getVideoCallStrategy = (): 'popup' | 'modal' | 'navigation' => {
  if (isCapacitorApp()) {
    // Native app: Use navigation or full-screen modal
    return 'navigation'
  }

  if (isMobileDevice() || isTouchDevice()) {
    // Mobile browsers: Use full-screen modal
    return 'modal'
  }

  if (shouldUsePopupWindow()) {
    // Desktop: Use popup window
    return 'popup'
  }

  // Fallback: Use modal
  return 'modal'
}

// Add type declarations for Capacitor
declare global {
  interface Window {
    Capacitor?: {
      platform: string
      isNative: boolean
    }
  }
}